var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInicio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.509,
    height: 37.953,
    viewBox: "0 0 42.509 37.953",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu-icons",
    transform: "translate(1.037 1.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic_inicio",
    d: "M23.713,35.7V23.283H16.045V35.7H7.727a3.479,3.479,0,0,1-3.533-3.421V19.736H1.29A2,2,0,0,1-.023,16.228L18.19.358a2,2,0,0,1,2.628,0l18.213,15.87a2,2,0,0,1-1.314,3.508h-2.9V32.278A3.479,3.479,0,0,1,31.28,35.7Z",
    transform: "translate(0.714 0.134)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInicio);
export default __webpack_public_path__ + "static/media/ic_inicio.4dadf6697bbc6ed09ce13de5625a8b98.svg";
export { ForwardRef as ReactComponent };